module.exports = __webpack_public_path__ + "static/media/three.996c8965.jpg";